import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import { Button, Menu, Dropdown, DropdownMenu, DropdownItem, Breadcrumb, BreadcrumbItem, Dialog, Autocomplete, Icon, RadioGroup, Radio, Tabs, TabPane, Carousel, CarouselItem, Input, Image, Tag, Option, OptionGroup, Loading, Form, FormItem, Popover, Select, Pagination, CheckboxGroup, Checkbox, Message, Table, TableColumn, Progress, Scrollbar, Steps, Step, Upload, MessageBox, Tooltip } from 'element-ui'
import router from './router/home'
import store from './store'
import * as filters from './filters' // global filters
import i18n from './i18n'
import 'element-ui/lib/theme-chalk/icon.css'
import './styles/home/index.scss'
import Filter from './components/Filter/index.vue'
import Empty from './components/Empty/index.vue'
import ECharts from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { LegendComponent, GridComponent, TooltipComponent } from 'echarts/components'
import MetaInfo from 'vue-meta-info'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import project from '../package.json'

import moment from 'moment'
moment.locale('zh_CN')

use([
  CanvasRenderer,
  PieChart,
  LegendComponent,
  GridComponent,
  TooltipComponent
])

Vue.component('v-chart', ECharts)
Vue.use(MetaInfo)
Vue.component('filterBox', Filter)
Vue.component('empty', Empty)
Vue.use(Button).use(Menu).use(Dropdown).use(DropdownMenu).use(DropdownItem)
  .use(Breadcrumb).use(BreadcrumbItem).use(Dialog).use(Autocomplete).use(Icon)
  .use(RadioGroup).use(Radio).use(CheckboxGroup).use(Checkbox).use(Tabs).use(TabPane).use(Image).use(Carousel)
  .use(CarouselItem).use(Input).use(Tag).use(Select).use(Popover).use(Pagination)
  .use(Option).use(OptionGroup).use(Loading).use(Form).use(FormItem).use(Breadcrumb).use(BreadcrumbItem)
  .use(Table).use(TableColumn).use(Progress).use(Scrollbar).use(Steps).use(Step).use(Upload).use(Tooltip)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

if (process.env.ENV_CONFIG === 'sit') {
  Sentry.init({
    Vue,
    dsn: 'https://074bc66d4a8d4492af3c8128fe2c70e2@sentry.szfzx.org/10',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['www.szfzx.org', 'www.srba.net.cn', /^\//]
      })
    ],
    tracesSampleRate: 1.0,
    release: project.name + '_v' + project.version + '_prod'
  })
}

new Vue({
  router,
  store,
  i18n,
  data: {
    eventHub: new Vue()
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js